// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ykdw7","content":"styles_content__AqbbO","sideBar__active":"styles_sideBar__active__Q00Vq","main":"styles_main__f19-X"};